"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allOriginFeatures = exports.OriginFeature = void 0;
const utils_1 = require("./utils");
var OriginFeature;
(function (OriginFeature) {
    OriginFeature["Bundles"] = "bundles";
    OriginFeature["Exchange"] = "exchange";
    OriginFeature["Seller"] = "seller";
    OriginFeature["Buyer"] = "buyer";
    OriginFeature["Devices"] = "devices";
    OriginFeature["DevicesImport"] = "devicesImport";
    OriginFeature["Certificates"] = "certificates";
    OriginFeature["CertificatesImport"] = "certificatesImport";
    OriginFeature["CertificationRequests"] = "certificationRequests";
    OriginFeature["IRec"] = "irec";
    OriginFeature["IRecConnect"] = "irecConnect";
    OriginFeature["IRecUIApp"] = "iRecUIApp";
    OriginFeature["NewInboxes"] = "newInboxes";
})(OriginFeature = exports.OriginFeature || (exports.OriginFeature = {}));
exports.allOriginFeatures = (0, utils_1.getEnumValues)(OriginFeature);
//# sourceMappingURL=OriginFeature.js.map